import React, { useEffect, useState } from 'react'
import './Pricing.css'
import { auth } from '../firebase'
import { onAuthStateChanged, signOut } from 'firebase/auth'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { cancelUtility, login } from './utility'
import Header from './Header'
import Footer from './Footer'

function Pricing({ usd, inr, server }) {
    let usdPrice = Math.round(inr / usd)
    const [userAuth, setUserAuth] = useState(null)
    const [userData, setUserData] = useState([])
    const [isSubscribed, setIsSubscribed] = useState(null)
    const [coupon, setCoupon] = useState('')
    const [load, setLoad] = useState(false)
    const [activeCurr, setActiveCurr] = useState('INR');
    // const [cValid, setCValid] = useState(false)
    const notify = () => toast.error('Please Login to continue', {
        autoClose: 2500
    })

    const cancel = async () => {
        try {
            const { user } = await cancelUtility(userData)
            setUserData(user)
            setIsSubscribed(user.isSubscribed)
            console.log(user)
        } catch (e) {
            console.log(e)
        }
    }

    const loginUser = () => login(userAuth)

    const logout = () => {
        signOut(auth)
        console.log('set false')
        setUserAuth(null)
        setUserData([])
        setIsSubscribed(false)
    }


    useEffect(() => {

        onAuthStateChanged(auth, user => {
            if (user) {
                console.log(user)
                fetch(server + '/user/' + user.email, {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                }).then(res => res.json()).then(data => {
                    setUserData(data)
                    setIsSubscribed(data.isSubscribed)
                    setLoad(true)

                })
                setUserAuth(user)

            } else {
                setUserAuth(null)
                setLoad(true)

            }
        })
        //eslint-disable-next-line
    }, [])

    const checkout = () => {

        fetch(server + '/checkout', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                items: [
                    { id: 1, quantity: 1 }
                ],
                "coupon": coupon,
                "email": userData.email
            })
        }).then(res => {
            if (res.ok) return res.json()
            return res.json().then(json => Promise.reject(json))
        }).then((data) => {
            window.location = data.url
            console.log(data)
        }).catch(e => {
            console.log(e.error)
        })

    }

    const startTrial = () => {
        console.log(userAuth)
        console.log(coupon)
        if (userAuth !== null) {
            checkout()
        } else {
            notify()
        }
    }

    const applyCoupon = async () => {
        let cop = coupon.trim()
        if (cop === "") {
            // add a notify error coupon is empty
            console.log('empty')
        } else {
            await fetch(server + '/coupon', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    coupon: cop
                })
            }).then(res => res.json()).then(data => {
                //  add a notify if coupon is valid
                // add a notify if coupon is not valid

                // setCValid(data.couponValid)
                if (data.couponValid) {

                    toast.success('Coupon applied successfully')
                } else {
                    toast.error('Coupon not valid')
                }
                // if coupon not valid set coupon to empty
            })
        }

    }



    return (
        <>
            <div className="pricing">
                {/* <header>
                <Link to="/">TubeLink</Link>
            </header> */}
                <Header user={userAuth} logout={logout} login={loginUser} />
                <ToastContainer />
                <main>
                    <div className="free_trial">
                        Start your FREE TRIAL
                    </div>
                    <div className="subscription_card">
                        {/* tube link logo */}
                        <div className="fake_logo">
                            <img src="Images/tubelink-logo.png" alt="logo" />
                        </div>

                        <div className="price">
                            <span className="currency">{activeCurr === "INR" ? "₹" : "$"}</span>
                            <span className="number">{activeCurr === "INR" ? inr : usdPrice}</span>
                            <span className="perMonth">/m</span>
                        </div>
                        <div className="currency_change">
                            <span className={activeCurr !== "INR" ? 'active_currency' : undefined} onClick={() => setActiveCurr('USD')}>USD</span>
                            <span> / </span>
                            <span className={activeCurr === "INR" ? 'active_currency' : undefined} onClick={() => setActiveCurr('INR')}>INR</span>
                        </div>
                        <div className="start_trial">
                            {!isSubscribed ? <button className='not_subscribed_btn' onClick={() => startTrial()}> START TRIAL</button> : <button className="subscribed" >SUBSCRIBED</button>}
                        </div>
                    </div>
                    {/* validate coupon */}
                    {/* apply coupon btn */}
                    {load && !isSubscribed && <div className="coupon">
                        <input type="text" placeholder='Coupon code' value={coupon} onChange={e => setCoupon(e.target.value)} />
                        <button className="coupon_btn" onClick={applyCoupon}>APPLY</button>
                    </div>}
                    {load && isSubscribed && <div className="cancel_sub" onClick={cancel}>Cancel Subscription</div>}
                </main>

                <div className="tag_line">
                    <span>SHARE LINK ONCE </span>
                    <span>FOR YOUR YOUTUBE VIDEOS</span>
                </div>

            </div>
            <Footer user={userAuth} login={loginUser} logout={logout} />
        </>
    )
}

export default Pricing